import AbstractRequestTask from "../AbstractRequestTask";
import DeviceStorage from "../../../components/DeviceStorage/DeviceStorage";
import Utils from "../../../utils/Utils";
import settings from "src/devices/all/settings";
import logger from 'src/utils/logger/logger';

class PureEpgTask extends AbstractRequestTask {
  constructor(parameters) {
    super();
    this.customParameters = parameters;
  }

  isValid(data){
    if(data.errors) {
      data.response = {
        channels:[],
        events:[]
      };
      return false;
    }
    return true;
  }

  getHeaders() {
    return {};
  }

    getParams() {
        const params = super.getParams();
        //for test
        //params.region = 'colombia'
        delete params.user_token;
        return {
            ...params,
            ...this.customParameters,
            epg_version: DeviceStorage.getItem('epgVersion') || false,
            soa_version: DeviceStorage.getItem('soaVersion') || false,
        };
    }

  getHostMiddleware(){
    if(settings.use_dexie){
      return process.env.VIDEO_MIDDLEWARE_URI
    }
    const host =    window.location.origin ? `${window.location.origin}/webapi-video/` :
      window.location.host ? `${window.location.protocol}//${window.location.host}/webapi-video/` :
        `${window.location.protocol}//${window.location.hostname}/webapi-video/`;
    logger.debug('PureEpgTask host',host);
    return host;
  }

  getUrl() {
    return `${this.getHostMiddleware()}pureEpg`;
  }

  getUrlWithQueryParams(){
    return `${this.getUrl()}?${Object.keys(this.getParams()).map(key => `${key}=${encodeURIComponent(this.getParams()[key])}`).join('&')}`
  }

  success(data, b) {
    this.resolve(data);
  }

  getShowErrorModal(){
    return Utils.showModalError();
  }
}

export default PureEpgTask;



// WEBPACK FOOTER //
// ./src/requests/tasks/epg/PureEpgTask.js